<visana-lib-popup
  *ngIf="showBackendErrorPopup$ | async as showBackendErrorPopup"
  [isOpen]="showBackendErrorPopup"
  [variant]="'red'"
  [title]="'GLOBAL.ERROR.TITLE' | translate"
  (cancel)="closePopup()"
  data-cy="backend-error-popup"
>
  <ng-container ngProjectAs="content">
    <div class="error-container">
      <visana-lib-icon
        *visanaLibHideForBreakpoint="'for-XSmall-Down'"
        iconColor="red"
        iconSize="64"
        name="warning"
      ></visana-lib-icon>
      {{ 'GLOBAL.ERROR.BACKEND.MESSAGE' | translate }}
      <visana-lib-icon
        *visanaLibShowForBreakpoint="'for-XSmall-Down'"
        iconColor="red"
        iconSize="48"
        name="warning"
      ></visana-lib-icon>
    </div>
  </ng-container>
</visana-lib-popup>
